import type { ModeFrais, NatureFrais } from '../shared'

export const NatureFraisAvecQuantite: Readonly<NatureFrais[]> = [] as const
export type NatureFraisAvecQuantite = (typeof NatureFraisAvecQuantite)[number]

export const NatureFraisAnnexe = ['Hebergement', 'Repas', 'Transport', 'AchatMateriel'] as const

export const NatureFraisPedagogique = [
  'Pedagogique',
  'BilanEvaluationInitiale',
  'EvaluationIntermediaireFinale',
  'CoutJuryFraisCertification',
  'IngenieriePrestationFraisAudit',
] as const

export const NaturesFrais: { [key in ModeFrais]: Readonly<NatureFrais[]> } = {
  Annexe: NatureFraisAnnexe,
  Pedagogique: NatureFraisPedagogique,
} as const

export const HelpFraisPedagogique: { [key in NatureFrais]?: string } = {} as const

export const HelpFraisAnnexe: { [key in NatureFrais]?: string } = {} as const
